import { render } from "./load-app.vue?vue&type=template&id=165a089a&scoped=true"
import script from "./load-app.vue?vue&type=script&lang=js"
export * from "./load-app.vue?vue&type=script&lang=js"

import "./load-app.vue?vue&type=style&index=0&id=165a089a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165a089a"]])

export default __exports__